import { render } from "./Menu.vue?vue&type=template&id=7f89077b&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=7f89077b&lang=scss&scoped=true"
import "./Menu.vue?vue&type=style&index=1&id=7f89077b&lang=scss"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f89077b"]])

export default __exports__